export default __webpack_public_path__ + "static/media/map-wash-icon.6fa649e0.svg";